var viVN = {
	"codeBlock.copied": "Đã sao chép",
	"codeBlock.copyLabel": "Sao chép",
	"inlineCodeBlock.copied": "Đã sao chép",
	"inlineCodeBlock.copyLabel": "Sao chép mã nội tuyến"
};

export { viVN as default };
